import axios from '../../axios';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
export const RESET_LOGIN = 'RESET_LOGIN';

export const USER = 'USER';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_NAME_CHANGE = 'USER_NAME_CHANGE';

const initialState = () => ({
    isLoggedIn: !!localStorage.getItem('token'),
    expire: ((new Date().getTime()) + (1000 * 60 * 60 * 24)),
    user: {},
});

const module = {
    state: initialState(),
    mutations: {
        [RESET_LOGIN] (s) {
            const initial = initialState();
            Object.keys(initial).forEach((key) => { s[key] = initial[key]; });
        },
        [LOGIN] (state) {
            state.showLoader = true;
        },
        [LOGIN_SUCCESS] (state) {
            state.isLoggedIn = true;
            state.showLoader = false;
        },
        [LOGIN_FAILED] (state) {
            state.isLoggedIn = false;
            state.showLoader = false;
        },
        [LOGOUT] (state) {
            state.isLoggedIn = false;
            state.showLoader = false;
        },
        [USER] (state) {
            state.showLoader = true;
        },
        [USER_SUCCESS] (state, payload) {
            state.showLoader = false;
            state.user = payload;
        },
        [USER_NAME_CHANGE] (state, payload) {
            state.user.voornaam = payload.voornaam;
            state.user.naam = payload.naam;
        },
    },
    actions: {
        changeName ({ commit }, payload) {
            commit(USER_NAME_CHANGE, payload);
        },
        login ({ commit }, payload) {
            commit(LOGIN);
            return new Promise((resolve, reject) => {
                axios.post(`/auth/login?email=${payload.account}&password=${payload.password}`)
                    .then((response) => {
                        if (response.data.logon === '1') {
                            localStorage.setItem('token', response.data.token);
                            axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
                            commit(LOGIN_SUCCESS);
                            commit(USER_SUCCESS, response.data.user);
                            resolve(response);
                        } else {
                            commit(LOGIN_FAILED);
                            reject();
                        }
                    },
                    (error) => {
                        commit(LOGIN_FAILED);
                        reject(error);
                    },
                    );
            });
        },
        logout ({ commit, dispatch }) {
            localStorage.removeItem('token');
            localStorage.removeItem('vuex');
            dispatch('resetAccountFilter');
            dispatch('resetBedrijfFilter');
            dispatch('resetAfdelingFilter');
            dispatch('resetAfdelingteeltFilter');
            commit(RESET_LOGIN);
            commit(LOGOUT);
        },
        getUser ({ commit }) {
            commit(USER);
            axios.get('/auth/user').then((response) => {
                commit(USER_SUCCESS, response.data);
            });
        },
    },
    getters: {
        isLoggedIn: state => state.isLoggedIn,
        expire: state => state.expire,
        user: state => state.user,
    },
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/login.js